/**
 * Date Chooser autohandler for all of BI dashboards and charts. Handles the Date range selector Javascript for all templates.
 * 
 * Usage:
 * 
 * data-sw-date-chooser
 */

'use strict';

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function ($fragment) {
  $fragment.swFindWithSelf('[data-sw-date-chooser]').each(function () {
    var $el = $(this);

    require([
      'js/DateChooser'
    ], function (DateChooser) {

      new DateChooser({
        el: $el
      });
    });
  });
};